import moment from "moment";
import DeliveryTypeContent from "./DeliveryTypeContent";
import {
  format12HourTime,
  format24HourTime,
  formatDate,
  formatFilterDate,
  formatTime,
  getWeekDay,
  isoDate,
} from "../../../../../../utils/common-utils";

export const prepareDeliveryTypes = (deliveryTypes, selectedType) => {
  const preparedTypes = [];

  deliveryTypes.forEach(({ deliveryType, unsupportedProducts }) => {
    const { code, id, timeline } = deliveryType;

    const standard = code === "std";
    const express = code === "express";
    const free = code === "free";

    preparedTypes.push({
      label: (
        <DeliveryTypeContent
          deliveryType={{
            ...deliveryType,
            standard,
            express,
            free,
            timelineSlot: selectedType.timeSlot || "",
          }}
          unsupportedProducts={unsupportedProducts}
        />
      ),
      value: id,
      express,
      standard,
      free,
      disabled: unsupportedProducts.length > 0,
      ...deliveryType,
      ...(timeline && {
        timeline: {
          ...timeline,
          intervals: filterValidIntervals(timeline.intervals),
        },
      }),
    });
  });

  return preparedTypes;
};

export const hasUnsupportedProducts = (deliveryTypes, typeId) => {
  const deliveryType = getDeliveryType(deliveryTypes, typeId);
  return Boolean(deliveryType.unsupportedProducts.length);
};

export const getDeliveryType = (deliveryTypes, typeId) => {
  return deliveryTypes.find((deliveryType) => deliveryType.id === typeId);
};

export const filterValidIntervals = (intervals) => {
  const currentDate = isoDate();

  return intervals.filter(
    ({ startDate, endDate }) =>
      !endDate || startDate <= currentDate || endDate >= currentDate
  );
};

const dateExistsInInterval = ({ endDate, date }) => {
  return endDate >= date || !endDate;
};

const getInterval = (intervals, date) => {
  return intervals.filter((item) => dateExistsInInterval({ ...item, date }));
};

const validateGraceTime = (date, endTime, graceHours) => {
  const formattedDate = formatDate(date);

  const graceHourDate = moment().add(graceHours, "hours");

  const formattedGraceHoursDate = formatDate(graceHourDate);
  const formattedGraceTime = formatTime("", "HH:mm:ss");

  let disabled = false;

  if (formattedGraceHoursDate > formattedDate) {
    disabled = true;
  } else if (formattedGraceHoursDate === formattedDate) {
    disabled = endTime < formattedGraceTime;
  }

  return { disabled };
};

const validateTime = (date, endSlotTime) => {
  const currentDate = formatDate(moment());
  const formattedDate = formatDate(date);

  const currentTime = format24HourTime(moment());
  const endTime = format24HourTime(date, endSlotTime);

  let disabled = currentDate === formattedDate && endTime < currentTime;

  return { disabled };
};

const prepareSlots = (durations, date, graceHours) => {
  return durations.map((item) => {
    const { startTime, endTime, id } = item;

    const formattedStartTime = format12HourTime(date, startTime, true);
    const formattedEndTime = format12HourTime(date, endTime, true);

    return {
      id,
      startTime,
      endTime,
      label: `${formattedStartTime} - ${formattedEndTime}`,
      value: id,
      date: formatFilterDate(date),
      ...(graceHours && validateGraceTime(date, endTime, graceHours)),
      ...(!graceHours && validateTime(date, endTime, graceHours)),
    };
  });
};

export const formatDeliveryDurations = ({ timeline, gracePeriodHours }) => {
  const monthDays = Array.from(Array(31).keys());

  let interval = "";
  let timeSlots = [];

  monthDays.forEach((dayNumber) => {
    const date = moment().add(dayNumber, "days");
    const formattedDate = formatDate(date);

    const dateInISO = isoDate(date);

    let weekDay = getWeekDay(date);

    if (
      !interval ||
      !dateExistsInInterval({ ...interval[0], date: dateInISO })
    ) {
      interval = getInterval(timeline.intervals, dateInISO);
    }

    const { durations } = interval[0];

    const dayDurations = durations.filter(
      ({ dayOfWeek }) => dayOfWeek === weekDay
    );

    if (dayDurations.length > 0) {
      timeSlots.push({
        date: formattedDate,
        slots: prepareSlots(dayDurations, date, gracePeriodHours),
      });
    } else {
      timeSlots.push({ date: formattedDate, slots: [] });
    }
  });

  return timeSlots;
};
